import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'

Vue.use(VueRouter)

export default new VueRouter({
  base: '/',
  mode: 'history',
  routes: [
        {
          path: '/',
          name: 'Home',
          component: require('@/views/AppFormView.vue').default
        } as RouteConfig
  ]
})
